import {
  GridRowModes,
  GridToolbarContainer,
  GridActionsCellItem,
  useGridApiRef,
  GridBooleanCell,
} from '@mui/x-data-grid-premium';
import { Box, Typography } from '@mui/material';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { dataGridPremiumColumns } from '../../utils/helper';
import { ButtonUI, DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import { useState } from 'react';
import { EmployeeAttendanceSimpleMode } from '../../utils/employeeAttendance';
import dayjs from 'dayjs';
import { formatCurrency, getRounding } from '../../utils/currencyHelper';

const ProjectSubcontractorsTable = ({ selectedValues }) => {
  const apiRef = useGridApiRef();

  const columns = dataGridPremiumColumns([
    {
      field: 'companyName',
      headerName: 'Megnevezés',
      type: 'string',
    },
    {
      field: 'docDate',
      headerName: 'Teljesítés dátuma',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.docDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.docDate).format('YYYY.MM.DD');
      },
    },

    {
      field: 'dueDate',
      headerName: 'Határidő',
      type: 'date',
      valueGetter: (_data, row) => {
        return new Date(row.dueDate);
      },
      renderCell: (data) => {
        return dayjs(data.row.dueDate).format('YYYY.MM.DD');
      },
    },
    {
      field: 'netInDocCur',
      headerName: 'Összesen nettó',
      type: 'number',
      renderCell: (data) => {
        return formatCurrency(data.row.netInDocCur);
      },
    },
    {
      field: 'VATInDocCur',
      headerName: 'Összesen Áfa',
      type: 'number',
      renderCell: (data) => {
        return formatCurrency(data.row.VATInDocCur);
      },
    },
    {
      field: 'sumInDocCur',
      headerName: 'Összesen bruttó',
      type: 'number',
      renderCell: (data) => {
        return formatCurrency(data.row.sumInDocCur);
      },
    },
    {
      field: 'currencyCode',
      headerName: 'Pénznem',
      type: 'string',
    },
    {
      field: 'reference',
      headerName: 'Hivatkozási szám',
      type: 'string',
    },
    {
      field: 'invoiced',
      headerName: 'Számlázva',
      type: 'boolean',
    },
    {
      field: 'note',
      headerName: 'Megjegyzés',
      type: 'string',
    },
  ]);

  return (
    <>
      <div className="overflow-x-auto">
        <div className="align-middle">
          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg">
            <DatagridPremiumUi
              apiRef={apiRef}
              datagridIdentifier={DataGridIdentifiers.ProjectSubcontractorsTable}
              height={460}
              columns={columns}
              rows={selectedValues.projectSubcontractors ?? []}
              headerFilters={false}
              slots={{
                toolbar: null,
              }}
              getRowHeight={() => 'auto'}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ProjectSubcontractorsTable;
